module.exports = __webpack_public_path__ + "img/2.9d2d0781.png";